/*
    Document   : main
    Created on : Apr 18, 2012, 12:03:15 PM
    Author     : TJ Beatrice <tj@artlabx.com>
*/


// brightcove API vars
var player;
var modVP;
var modExp;
var modCon;

// DOM entry point
$(document).ready(function()
{
    initSlides();
});

// usage: log('inside coolFunc',this,arguments);
// http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
window.log = function()
{
    log.history = log.history || [];   // store logs to an array for reference
    log.history.push(arguments);
  if(this.console)
  {
        console.log(Array.prototype.slice.call(arguments));
    }
};

// ------
// slides
// ------
function initSlides()
{
    $('#brightcove-player').hide();

    if ($("#slides").slides) {
        $("#slides").slides({
            generateNextPrev: true,
            generatePagination: true,
            animationStart: slideAnimStart,
            slideSpeed: 700,
            play: 5000
        });
    }

    $("#slides a.playvideo").click(function () {

        var t = $(this);
        var imageurl = t.attr('href');
        if (imageurl == '#') {
            var slidediv = t.parent().parent();
            var vidid = t.attr('rel');

            // stop slides
            clearInterval($("#slides").data('interval'));

            // hide photo and panel
            slidediv.children('.photo-horiz').hide();
            slidediv.children('.panel').hide();

            // show video and play
            $('#brightcove-player').show();
            $('#brightcove-player').css('z-index', '9999');
            BCL.addPlayer(vidid);
        }
        else {
            window.location = encodeURI(imageurl);
        }
        return false;
    });

}


function slideAnimStart()
{
    // reset video slides
    $("#slides .slide").each(function (idx) {
        var slidediv = $(this);
    if(slidediv.find('a.playvideo').length > 0)
    {
            //log('slideAnimStart() idx: ' + idx)

            // reveal photo and panel
            slidediv.children('.photo-horiz').show();
            slidediv.children('.panel').show();

            // pause video and hide
            if (modVP != undefined) modVP.pause(true);
            $('#brightcove-player').hide();
        }
    });
}

// ------
// Brightcove API
// ------
function myTemplateLoaded(experienceID) {
    player = brightcove.api.getExperience(experienceID);
    modVP = player.getModule(brightcove.api.modules.APIModules.VIDEO_PLAYER);
    modExp = player.getModule(brightcove.api.modules.APIModules.EXPERIENCE);
    modCon = player.getModule(brightcove.api.modules.APIModules.CONTENT);
}

function onTemplateReady(evt) {
    modVP.addEventListener(brightcove.api.events.MediaEvent.BEGIN, onMediaEventFired);
    modVP.addEventListener(brightcove.api.events.MediaEvent.CHANGE, onMediaEventFired);
    modVP.addEventListener(brightcove.api.events.MediaEvent.COMPLETE, onMediaEventFired);
    modVP.addEventListener(brightcove.api.events.MediaEvent.ERROR, onMediaEventFired);
    modVP.addEventListener(brightcove.api.events.MediaEvent.PLAY, onMediaEventFired);
    modVP.addEventListener(brightcove.api.events.MediaEvent.STOP, onMediaEventFired);
}

function onMediaEventFired(evt) {
    log("MEDIA EVENT: " + evt.type + " fired at position: " + evt.position);
}


/**
 * modified heaviy from: http://developer.brightcove.com/en/articles/dynamically-loading-player-using-javascript
 * NOTE: script at URL had syntax error 
 * iOS would not allow the player to be re-used (as intended by URL script) when hiding/showing div.  Instead player HTML must be re-injected into the DOM and the player re-instantiated each time video is played.
 */
// namespace to keep the global clear of clutter
var BCL = {};

BCL.addPlayer = function (vidid) {

    BCL.isPlayerAdded = true;
    var html = $('.video-player' + vidid).html();
    $("#brightcove-player").html(html);
    brightcove.createExperiences();
};

//#region brand replacement
function replaceBrandText(classArray, replaceText) {
    try {
        classArray.forEach(function (c) {
            var elems = document.getElementsByTagName('*'), i;
            for (i in elems) {
                if ((' ' + elems[i].className + ' ').indexOf(' ' + c + ' ') > -1) {
                    var bodyHtml = elems[i].innerHTML;
                    Object.keys(replaceText).forEach(function (key) {
                        var re = new RegExp(key, "gi");
                        var replaceTextMatchArray = bodyHtml.match(re);
                        if (replaceTextMatchArray != null) {
                            replaceTextMatchArray.forEach(function (m) {
                                var replacedText = m.replace(re, replaceText[key]);
                                if (replacedText != null) {
                                    bodyHtml = bodyHtml.replace(re, replacedText);
                                }
                            });
                        }
                        document.title = document.title.replace(re, replaceText[key]);
                    });
                    elems[i].innerHTML = bodyHtml;
                }
            }
        });
    }
    catch (err) {
        // nothing here
    }
}
//#endregion

// iframe resizing event
window.addEventListener('message', function (event) {
  if (event.srcElement.e) {
    var model = ParseJsonString(event.data);
    if (!model || !model.heightSetting || (!model.minHeight && !model.doReset)) {
      return;
    }

    var $targetFrame = $(event.srcElement.e);
    if (model.doReset) {
      var originalHeightData = $targetFrame.data("original-height");
      if (originalHeightData) {
        $targetFrame.css("min-height", originalHeightData);
        $targetFrame.data("original-height", 0);
      }
      return;
    }

    if (model.minHeight > parseInt($targetFrame.css("min-height").replace("px", ""))) {
      $targetFrame.data("original-height", $targetFrame.height());
      $targetFrame.css("min-height", model.minHeight);
    }
  }
});

$(document).ready(function () {
    // HIDE SLIDER IMAGE RENDERING - opacity will initially  be set to 0 in main.css
    setTimeout(function () {
        $('#main-slick-slider, #secondary-slider').css({ 'opacity': '1' });
    }, 500);

    $('#bottom-slick-slider').parent().attr('class', 'bottom-slick-slider-container');

    var subscribe = $('.hp-subscribe');
    $('.hp-subscribe').remove();
    $('.rightColHome').append(subscribe);
});

function ParseJsonString(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
}